// @flow
import { useTranslator } from '@gandi/translate';
import { IconButton } from '@gandi/ui';

import styles from './RemoveButton.scss';

type Props = {
  discount:
    | {
        code?: string,
        amount: number,
        label: string,
      }
    | {
        id: number,
        label: string,
      },
  handleRemoveAction: (SyntheticEvent<HTMLButtonElement>) => mixed,
  loading: boolean,
};
export function RemoveButton({
  discount,
  handleRemoveAction,
  loading,
}: Props): React.MixedElement | null {
  const { __ } = useTranslator();
  if (!discount.code && !discount.id) return null;

  return (
    <IconButton
      icon="trash"
      small
      kind="ghost"
      className={styles.root}
      onClick={handleRemoveAction}
      loading={loading}
    >
      {__('Remove code')}
    </IconButton>
  );
}
